import React from 'react';

import SearchMenu, { FilterConsumer } from '../components/SearchMenu';
import Zone from './Zone';

function ZoneIndex() {
  return (
    <SearchMenu>
      <FilterConsumer>{({ agencies }) => <Zone filter={agencies} />}</FilterConsumer>
    </SearchMenu>
  );
}

export default ZoneIndex;
